import { inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

/**
 * **Must be run in DI context.**
 *
 * Returns a function that navigates relative to the current route.
 *
 * #### Example
 *
 *     \@Component({
 *       // ...
 *     })
 *     export class MyComponent {
 *       private readonly navigateRelative = mkNavigateRelative();
 *
 *       navigateUp() {
 *         // Navigate up one level
 *         this.navigateRelative(['..']);
 *       }
 *     }
 */
export function mkNavigateRelative() {
  const activatedRoute = inject(ActivatedRoute);
  const router = inject(Router);
  return (commands: any[], extras?: NavigationExtras) =>
    router.navigate(commands, { ...extras, relativeTo: activatedRoute });
}
